<ng-container *ngIf="batchMode.isActive else normalMode">
  <button class="btn float-right no-selection" (click)="takeAction()" [ngClass]="countSelectedRequests() > 0 ? 'selection' : 'no-selection'">
    <i class="fa fa-check" aria-hidden="true"></i>
    {{buttonLabel | translate}} {{countSelectedRequests()}} {{'components.requestInBatch.requests' | translate}}
  </button>
  <button class="btn btn-default float-right" (click)="desactivateBatchMode()">Annuler</button>
</ng-container>
<ng-template #normalMode>
  <button class="btn btn-default float-right" (click)="router.navigate(['edit-request-in-batch'])">
    <i class="fa fa-pencil" aria-hidden="true"></i>
    {{ "components.requestInBatch.updateInBatch" | translate }}
  </button>
</ng-template>